var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvoicing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.633,
    height: 22.054,
    viewBox: "0 0 20.633 22.054",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "test_4_",
    "data-name": "test (4)",
    transform: "translate(-16.5 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1361",
    "data-name": "Path 1361",
    d: "M84.592,145H81.146a.646.646,0,0,0,0,1.292h3.446a.646.646,0,0,0,0-1.292Z",
    transform: "translate(-61.243 -138.754)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1362",
    "data-name": "Path 1362",
    d: "M84.592,225H81.146a.646.646,0,0,0,0,1.292h3.446a.646.646,0,0,0,0-1.292Z",
    transform: "translate(-61.243 -215.308)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    d: "M84.592,305H81.146a.646.646,0,0,0,0,1.292h3.446a.646.646,0,0,0,0-1.292Z",
    transform: "translate(-61.243 -291.862)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    d: "M32.61,11.843v-5.9a3.212,3.212,0,0,0-.925-2.263L29.064.97l0,0A3.252,3.252,0,0,0,26.756,0H18.438A1.941,1.941,0,0,0,16.5,1.938V18.695a1.941,1.941,0,0,0,1.938,1.938h9.986a5.136,5.136,0,1,0,4.185-8.79ZM17.792,18.695V1.938a.647.647,0,0,1,.646-.646h8.317a1.952,1.952,0,0,1,1.381.578l2.621,2.711,0,0a1.927,1.927,0,0,1,.556,1.359v5.9a5.124,5.124,0,0,0-3.876,7.5h-9a.647.647,0,0,1-.646-.646Zm14.172,2.068a3.834,3.834,0,1,1,3.877-3.834A3.838,3.838,0,0,1,31.964,20.762Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1365",
    "data-name": "Path 1365",
    d: "M332.969,354.151a.646.646,0,0,0-.91.083l-1.091,1.309-.247-.495a.646.646,0,1,0-1.156.578l.689,1.378a.646.646,0,0,0,1.074.125l1.723-2.068A.646.646,0,0,0,332.969,354.151Z",
    transform: "translate(-299.515 -338.753)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1366",
    "data-name": "Path 1366",
    d: "M241.146,146.292h.689a.646.646,0,0,0,0-1.292h-.689a.646.646,0,0,0,0,1.292Z",
    transform: "translate(-214.351 -138.754)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1367",
    "data-name": "Path 1367",
    d: "M242.481,225.646a.646.646,0,0,0-.646-.646h-.689a.646.646,0,1,0,0,1.292h.689A.646.646,0,0,0,242.481,225.646Z",
    transform: "translate(-214.351 -215.308)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicing);
export default __webpack_public_path__ + "static/media/invoicing.c5be373cf4cf813d5aac0aacc0d2eb6d.svg";
export { ForwardRef as ReactComponent };